import { Attributes, DateUtils, Misc, Rules, ValueObject } from '@singularsystems/neo-core';
import { NeoModel } from "@singularsystems/neo-core";
import { TradeOrderStatus } from '../Enums/TradeOrderStatus';

@NeoModel
export default class TradeOrderSearchCriteria extends ValueObject {

    constructor() {
        super();
    }

    @Attributes.Display("Trade Description")
    public tradeDescription: string = "";

    @Attributes.Display("Reference Number")
    public referenceNumber: string = "";

    @Attributes.Display("From Date")
    @Attributes.Date(Misc.TimeZoneFormat.None)
    @Rules.Required()
    public fromDate: Date | null = DateUtils.add(new Date(), { months: -3 });

    @Attributes.Display("To Date")
    @Attributes.Date(Misc.TimeZoneFormat.None)
    @Rules.Required()
    public toDate: Date | null = new Date();

    @Attributes.Display("Trade Order Status")
    public tradeOrderStatusId: TradeOrderStatus | null = null;

    @Attributes.Display("Broker")  // Changed from "Static Service Provider File Grouping"
    public staticServiceProviderFileGroupingID: number | null = null;

    @Attributes.Display("Search")
    public searchCriteria: string = "";
}